export const MainContent = {
	heading: 'Member demographics',
};

export const InvestorMovementContent = {
	heading: 'Investor Movement as at ',
	startDate: 'Investors as at date: ',
	exits: 'Exits: ',
	newInvestors: 'New investors: ',
	totalInvestors: 'Total investors: ',
};

export const BenefitGroupsContent = {
	heading: 'Benefit Groups as at ',
	table: {
		staffGroupsHeader: 'Staff groups',
		investorsHeader: 'Investors',
		statusHeader: 'Status',
	},
	select: {
		label: 'Filter status:',
		id: 'group-filter',
		options: {
			all: 'All',
			open: 'Open',
			closed: 'Closed',
		},
	},
};

export const AvgInvestorBalanceContent = {
	heading: 'Average Investor Balance as at ',
	table: {
		ageHeader: 'Age',
		avgBalanceHeader: 'Av. Balance',
		investorsHeader: 'Investors',
	},
};
